module.exports = __webpack_public_path__ + "static/manufacturing-25f724211556c3f77decbdeee845ebb9.png";